/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import * as Dashboard from './Dashboard';
import * as DataTable from './DataTable';
import * as DownloadDataTable from './DownloadDataTable';
// import * as SignIn from './SignIn';
import * as User from './User';
import * as RoleModule from './Role'
import * as Notification from './Notification'
import * as UploadManual from './UploadManual'
import * as UploadBulletin from './UploadBulletin'
import * as ViewManual from './ViewManual'
import * as UploadDownloads from './UploadDownloads'
import * as UploadConstants from './UploadConstants'
import * as ViewDownloads from './ViewDownloads'
import * as ViewBulletin from './ViewBulletin'
import * as ViewLaborTimeGuide from './ViewLaborTimeGuide'
import watch from 'redux-watch'
import * as NavMenu from './NavMenu';
import * as ViewGeneralServiceInformation from './ViewGeneralServiceInformation'
import * as UploadGSInfo from './UploadGSInfo'
import * as AuthService from '../services/AuthServices';
import * as InstrumentConstants from '../store/ViewInstrumentConstants';


export default function configureStore(initialState?: any) {
  const reducers = {
        dashboard: Dashboard.reducer,
        dataTable: DataTable.reducer,
        //signIn: SignIn.reducer,
        downloadDataTable: DownloadDataTable.reducer,
        user: User.reducer,
        roleModule: RoleModule.reducer,
        notification: Notification.reducer,
        viewManual: ViewManual.reducer,
        uploadManual: UploadManual.reducer,
        viewDownloads: ViewDownloads.reducer,
        uploadDownloads: UploadDownloads.reducer,
        uploadConstants: UploadConstants.reducer,
        uploadBulletin: UploadBulletin.reducer,
        viewBulletin: ViewBulletin.reducer,
        viewLaborTimeGuide: ViewLaborTimeGuide.reducer,
        viewGeneralServiceInformation: ViewGeneralServiceInformation.reducer,
        uploadGSInfo: UploadGSInfo.reducer,
        navMenu: NavMenu.reducer,
        authService: AuthService.reducer,
        instrumentConstants: InstrumentConstants.reducer
    }

  // Use thunk middleware

  const rootReducer = combineReducers({
    ...reducers
  });

  const windowIfDefined = typeof window === 'undefined' ? null : window as any;
  const composeEnhancers = (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk))
  );

  const w = watch(store.getState, 'notification.totalCount')

  store.subscribe(w((newVal: any, oldVal: any, objectPath: string) => {
    if (objectPath == 'notification.totalCount' && oldVal != newVal) {
        let notificationCountChangeEvent = new CustomEvent(
            "notificationCountChange",
            {
                detail: {
                    oldCount: (oldVal == undefined || oldVal == null) ? 0 : oldVal,
                    newCount: (newVal == undefined || newVal == null) ? 0 : newVal
                },
                bubbles: true,
                cancelable: true
            }
       
        );
        document.dispatchEvent(notificationCountChangeEvent);
    }
  }))
  return store
}
